import React from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import '../App.css';
import modules from '../modules';
import Helper from '../utility/helper';
import UnauthorizedUI from '../sharedcomponents/emptyStateContainer/unauthorizedUI';
import RouteConstants from '../constants/routeConstants';

const InnerRouter = () => {
    // const [currentTab, setCurrentTab] = useState('dashboard');
    const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');

    const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');
    const UserEvents = Helper.getStorage('UserEvents');

    let eventURL = useLocation();
    let routeFlag = true;
    let urlElements = eventURL.pathname.split('/');
    if (urlElements[2]) {
        let eventID = parseInt(urlElements[2]);
        let val = Helper.CheckNumberOrString(urlElements[2]);
        if (val === 'number') {
            routeFlag = UserEvents.length > 0 ? UserEvents.some((ele) => ele.eventID === eventID) : UserEvents;
        }
    }

    const checkRoutePath = (path, check) => {
        if (typeof path === 'string') {
            return path.includes(check);
        } else {
            return path ? path.some((inPath) => inPath.includes(check)) : false;
        }
    };

    const checkRoutes = (module) => {
        if (userInfo) {
            if (module.routeProps.path == '/sessionTimeOut') {
                return <Route exact {...module.routeProps} key={module.name} />;
            } else if (
                module.routeProps.path == '/' ||
                module.routeProps.path == RouteConstants.PROFILE ||
                module.routeProps.path == RouteConstants.IN_APP_NOTIFICATIONS ||
                module.routeProps.path ==
                RouteConstants.SOCIAL_RESPONSIBILITY ||
                module.routeProps.path == RouteConstants.SETTINGS ||
                module.routeProps.path == RouteConstants.CHARGE_CARD ||
                module.routeProps.path == RouteConstants.CREDENTIAL_LIST ||
                module.routeProps.path == RouteConstants.CREDENTIALS ||
                module.routeProps.path == RouteConstants.COMBINE_FLIGHT_INFO ||
                module.routeProps.path == RouteConstants.MY_STATS_REPORT ||
                module.routeProps.path == RouteConstants.LUNCHROOM ||
                module.routeProps.path == RouteConstants.LUNCHROOM_LIST ||
                module.routeProps.path == RouteConstants.GREENROOM ||
                module.routeProps.path == RouteConstants.GREENROOM_LIST ||
                module.routeProps.path == RouteConstants.DRAFT_FLIGHT_INFO_ADMIN_LIST ||
                module.routeProps.path == RouteConstants.DRAFT_FLIGHT_INFO_LIST
            ) {
                return <Route exact {...module.routeProps} key={module.name} />;
            } else if (
                module.routeProps.path != '/' &&
                module.routeProps.path != '/sessionTimeOut' &&
                Helper.isAdminUser(userInfo)
            ) {
                return <Route exact {...module.routeProps} key={module.name} />;
            } else {
                let checkPath = checkRoutePath(
                    module.routeProps.path,
                    '/events/'
                );
                if (checkPath) {
                    // console.log("checkPath",checkPath);

                    if (Helper.isEventAdmin(userInfo)) {
                        return (
                            <Route
                                exact
                                {...module.routeProps}
                                key={module.name}
                            />
                        );
                    } else if (
                        !Helper.isEventAdmin(userInfo) &&
                        Helper.isEventStaff(userInfo) &&
                        (module.routeProps.path ==
                            RouteConstants.EVENT_DETAIL ||
                            module.routeProps.path ==
                            RouteConstants.EVENT_SCHEDULE ||
                            module.routeProps.path ==
                            RouteConstants.EVENT_STAFF_SCHEDULE ||
                            module.routeProps.path ==
                            RouteConstants.USER_ACTIVITIES ||
                            module.routeProps.path ==
                            RouteConstants.MY_RESOURCE ||
                            module.routeProps.path ==
                            RouteConstants.SOCIAL_RESPONSIBILITY ||
                            module.routeProps.path ==
                            RouteConstants.EVENT_TICKET_PARTICIPANT ||
                            module.routeProps.path,
                            RouteConstants.MODULE || module.routeProps.path,
                            RouteConstants.EVENT_DRAFT_HOTEL ||
                            module.routeProps.path,
                            RouteConstants.CREDENTIALS ||
                            module.routeProps.path,
                            RouteConstants.LUNCHROOM ||
                            module.routeProps.path,
                            RouteConstants.GREENROOM ||
                            module.routeProps.path,
                            RouteConstants.DRAFT_FLIGHT_INFO_ADMIN_LIST ||
                            module.routeProps.path,
                            RouteConstants.COMBINE_FLIGHT_INFO ||
                            module.routeProps.path,
                            RouteConstants.EVENT_ALLSTAR_HOTEL ||
                            module.routeProps.path,
                            RouteConstants.EVENT_NOTES_USER ||
                            module.routeProps.path,
                            RouteConstants.END_USER_EVENT_INSTRUCTION ||
                            module.routeProps.path,
                            RouteConstants.EVENT_NOTES_DETAILS)
                    ) {
                        return (
                            <Route
                                exact
                                {...module.routeProps}
                                key={module.name}
                            />
                        );
                    }
                    // else if (
                    //     !Helper.isEventAdmin(userInfo) &&
                    //     Helper.isEventStaff(userInfo) &&
                    //     (module.routeProps.path ==
                    //         RouteConstants.EVENT_DETAIL ||
                    //         module.routeProps.path ==
                    //         RouteConstants.USER_ACTIVITIES ||
                    //         module.routeProps.path ==
                    //         RouteConstants.MY_RESOURCE ||
                    //         module.routeProps.path ==
                    //         RouteConstants.SOCIAL_RESPONSIBILITY ||
                    //         module.routeProps.path ==
                    //         RouteConstants.EVENT_TICKET_PARTICIPANT ||
                    //         module.routeProps.path,
                    //         RouteConstants.MODULE
                    //     )
                    // ) {
                    //     return (
                    //         <Route
                    //             exact
                    //             {...module.routeProps}
                    //             key={module.name}
                    //         />
                    //     );
                    // }
                    else if (
                        (!Helper.isEventAdmin(userInfo) &&
                            !Helper.isEventStaff(userInfo) &&
                            (checkRoutePath(
                                module.routeProps.path,
                                RouteConstants.EVENT_DETAIL
                            ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.EVENT_REGISTER_CREATE
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.EVENT_ALLSTAR_REGISTER_CREATE
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.EVENT_DRAFT_REGISTER_CREATE
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.CREATE_GREEN_ROOM
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.EVENT_ALLSTAR_EDIT_REGISTER
                                ) ||
                                // checkRoutePath(module.routeProps.path, RouteConstants.EVENT_EDIT_REGISTER) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.EVENT_TRANSIT
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.DRAFT_EVENT_TRANSIT
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.EVENT_CREATE_TRANSIT
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.DRAFT_EVENT_CREATE_TRANSIT
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.DRAFT_COMBINE_EVENT_TRANSIT
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.DRAFT_COMBINE_EVENT_CREATE_TRANSIT
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.DRAFT_COMBINE_EVENT_CREATE_TRANSIT
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.EVENT_VIP
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.ASSIGN_ACTIVITIES
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.ALL_ACTIVITIES
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.MARK_ACTIVITIES
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.EVENT_EDIT_TRANSIT
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.EVENT_TICKETS
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.All_STAR_TIKCET
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.All_STAR_END_USER_TIKCETS
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.CREATE_EVENT_TICKET
                                ) ||
                                // checkRoutePath(module.routeProps.path, RouteConstants.EVENT_TRANSIT_LIST) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.EVENT_HOTEL
                                ) ||
                                // checkRoutePath(module.routeProps.path, RouteConstants.EVENT_HOTEL_BOOKING_LIST) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.CREATE_EVENT_HOTEL
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.EDIT_HOTEL_EVENT
                                ) ||
                                // checkRoutePath(module.routeProps.path, RouteConstants.EVENT_REGISTRATION_LIST) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.EVENT_DRAFT_HOTEL
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.CREDENTIALS
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.LUNCHROOM
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.GREENROOM
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.COMBINE_FLIGHT_INFO
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.DRAFT_FLIGHT_INFO_LIST
                                )
                                ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.DRAFT_CREATE_FLIGHT_INFO
                                )
                                ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.DRAFT_EDIT_FLIGHT_INFO
                                ) ||
                                // checkRoutePath(module.routeProps.path, RouteConstants.EVENT_HOTEL_BOOKING_LIST) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.CREATE_DRAFT_EVENT_HOTEL
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.EDIT_DRAFT_HOTEL_EVENT
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.EVENT_ALLSTAR_HOTEL
                                ) ||
                                // checkRoutePath(module.routeProps.path, RouteConstants.EVENT_HOTEL_BOOKING_LIST) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.CREATE_ALLSTAR_EVENT_HOTEL
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.EDIT_ALLSTAR_HOTEL_EVENT
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.EVENT_SCHEDULE
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.USER_ACTIVITIES
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.SIGNUP
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.FORGOT_PASSWORD
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.RESET_PASSWORD
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.EVENT_AGENT_PROFILE
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.EVENT_SAT_NIGHT_TRANSPORT
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.EVENT_SAT_NIGHT_TRANSPORT_CREATE
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.EVENT_SAT_NIGHT_TRANSPORT_EDIT
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.EVENT_SAT_NIGHT_TRANSPORT_ENDUSER_CREATE
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.PRIVATE_VEHICLE_ENDUSER_CREATE
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.CREDENTIALS
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.LUNCHROOM
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.GREENROOM
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.COMBINE_FLIGHT_INFO
                                ) ||
                                checkRoutePath(
                                    module.routeProps.path,
                                    RouteConstants.EVENT_MEDIA_CIRCUIT
                                ))) ||
                        checkRoutePath(
                            module.routeProps.path,
                            RouteConstants.CREATE_OUTFIT
                        ) ||
                        checkRoutePath(
                            module.routeProps.path,
                            RouteConstants.MY_RESOURCE
                        ) ||
                        checkRoutePath(
                            module.routeProps.path,
                            RouteConstants.SOCIAL_RESPONSIBILITY
                        ) ||
                        checkRoutePath(
                            module.routeProps.path,
                            RouteConstants.EVENT_TICKET_PARTICIPANT
                        ) ||
                        checkRoutePath(
                            module.routeProps.path,
                            RouteConstants.EVENT_STAFF_SCHEDULE
                        ) ||
                        checkRoutePath(
                            module.routeProps.path,
                            RouteConstants.EVENT_NOTES_USER
                        ) ||
                        checkRoutePath(
                            module.routeProps.path,
                            RouteConstants.END_USER_EVENT_INSTRUCTION
                        ) ||
                        checkRoutePath(
                            module.routeProps.path,
                            RouteConstants.EVENT_NOTES_DETAILS
                        )
                    ) {
                        return (
                            <Route
                                exact
                                {...module.routeProps}
                                key={module.name}
                            />
                        );
                    } else {
                        return (
                            <Route
                                exact
                                path={module.routeProps.path}
                                component={UnauthorizedUI}
                                key={module.name}
                            />
                        );
                    }
                } else {
                    return (
                        <Route
                            exact
                            path={module.routeProps.path}
                            component={UnauthorizedUI}
                            key={module.name}
                        />
                    );
                }
            }
        } else {
            return (
                <Route
                    exact
                    path={module.routeProps.path}
                    component={UnauthorizedUI}
                    key={module.name}
                />
                // <Box>No access2</Box>
            );
        }
    };
    const UnautorizedRoute = () => {
        return <Route exact component={UnauthorizedUI} />;
    };

    return (
        <Switch>
            {routeFlag
                ? modules.map((module) => checkRoutes(module))
                : UnautorizedRoute()}
        </Switch>
    );
};

export default InnerRouter;
